import { generateLazyContext } from './LazyContext';
import { UUID } from '../types/uuid';
import { IBasicOrganization } from '../resources/models/IOrganization';

export type TLazyOrganization = Pick<IBasicOrganization, 'id' | 'name'>;

export const LazyOrganizationContext = generateLazyContext<TLazyOrganization, UUID>();
